<!-- <div class="logout">
    <button class="btn btn-sec lg icon-start" (click)="logout()">
        <span class="material-symbols-outlined">
            logout
        </span>
        Logout
    </button>
</div> -->
<div class="container box-ogz">
    <div class="row justify-content-center">
        <div class="col-md-6 col-12">
            <h1 *ngIf="systemid == '2966ad39-1412-41f2-8616-b0555b1ae7f9'">รายการร้านทั้งหมด</h1>
            <h1 *ngIf="systemid != '2966ad39-1412-41f2-8616-b0555b1ae7f9'">Organizations</h1>
            <button *ngIf="companyItem" class="btn lg me-2 d-flex align-items-center shadow" [ngStyle]="{
  'background': styleItems.BtnBackground,
  'color': styleItems.BtnColor,
  'border-radius': styleItems.BtnBorderRadius,
  'height': styleItems?.BtnHeight,

}" (click)="actionView=true">
                <span class="material-symbols-outlined me-2">
                    apartment
                </span>
                <span *ngIf="systemid == '2966ad39-1412-41f2-8616-b0555b1ae7f9'">
                    สร้างร้าน
                </span>
                <span *ngIf="systemid != '2966ad39-1412-41f2-8616-b0555b1ae7f9'">
                    Create Organization
                </span>
            </button>
        </div>

    </div>
    <br>
    <div class="row justify-content-center">
        <div class="col-md-6 col-12">
            <p class="p-0 m-0" *ngIf="systemid == '2966ad39-1412-41f2-8616-b0555b1ae7f9'">เลือกร้านค้า</p>
        </div>
    </div>
    <div class="row justify-content-center" *ngFor="let cm of companyItem">
        <div class="col-md-6 col-12">
            <div class="shadow-sm p-3 mb-2 mt-2 bg-body action" [style.--btn-hover-bg]="ds.styleItems?.BtnBackground"
                (click)="toSystem(cm)">
                <div class="d-flex align-items-center">
                    <span class="material-symbols-outlined me-2">
                        apartment
                    </span>
                    <span>{{cm.Organization_name}}</span>
                    <span class="ms-auto pt-1 pb-1 ps-2 pe-2" [ngStyle]="{
                        'background': styleItems.BtnBackground,
                        'color': styleItems.BtnColor,
                        'border-radius': styleItems.BtnBorderRadius,
                    }">เข้าใช้งาน</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row g-3 mt-5 justify-content-center" *ngIf="!companyItem">
        <div class="col-xl-6 col-lg-6 col-12 mt-3">
            <app-settig-company (updateItem)="updateItem($event)"></app-settig-company>
        </div>
    </div>
    <br><br><br>
</div>


<p-dialog header="Create Organization" [(visible)]="actionView" [breakpoints]="{ '960px': '90vw' }"
    [style]="{ width: '50vw' }" (onHide)="close()">
    <app-settig-company *ngIf="!ds.loading" (updateItem)="updateItem($event)"></app-settig-company>
</p-dialog>